import type { CmsProps } from '../../types/cms'
import { Box, Stack } from '@mui/material'
import { MarkdownText } from 'ui-kit'
import { CmsButton } from '../Button'
import { GradientContainer, MobileHeaderContainer } from './styles'
import TechnologyLogo from '../TechnologyLogo'
import FormattedImage from '../FormattedImage'
import IconChip from '../IconChip'

const MobileTechnologyHeader = ({
  mobileHeaderColour,
  gradientHeight,
  logo,
  title,
  info,
  titleColour,
  chip,
  mobileBackgroundImage,
  buttons,
  isHomepage,
}: CmsProps) => {
  return (
    <MobileHeaderContainer titleColour={titleColour}>
      <Box
        sx={{
          display: {
            xs: 'block',
            md: 'none',
          },
        }}
      >
        <GradientContainer
          headerColor={mobileHeaderColour}
          height={gradientHeight}
        >
          <Stack
            justifyContent={'center'}
            alignItems={'center'}
            spacing={4}
            pt={4}
          >
            <TechnologyLogo logo={logo} mobile />
            <Box px={5}>
              <MarkdownText
                components={
                  isHomepage
                    ? { h1: ({ children }) => <h2>{children}</h2> }
                    : undefined
                }
              >
                {title}
              </MarkdownText>
            </Box>
            {chip?.data?.attributes && <IconChip {...chip.data.attributes} />}
            <Box px={2}>
              <MarkdownText>{info && info}</MarkdownText>
            </Box>
          </Stack>
        </GradientContainer>
        <Box
          sx={{
            backgroundColor: mobileHeaderColour,
            '& span': {
              width: '100% !important',
            },
            '& img': {
              objectFit: 'cover',
              objectPosition: 'center',
              width: '100% !important',
            },
          }}
        >
          <FormattedImage image={mobileBackgroundImage} responsive />
        </Box>
        <Stack
          spacing={2}
          direction={{ xs: 'row-reverse', md: 'row' }}
          justifyContent={buttons.length > 1 ? 'space-evenly' : 'center'}
          sx={{
            paddingBottom: 3,
            backgroundColor: mobileHeaderColour,
            '& button': {
              width: '10.5rem',
            },
            height: isHomepage && '8rem',
          }}
        >
          {buttons.map(({ backgroundColour, text, link, textColour }) => (
            <CmsButton
              backgroundColor={backgroundColour}
              color={textColour}
              href={link}
              key={text}
            >
              {text}
            </CmsButton>
          ))}
        </Stack>
      </Box>
    </MobileHeaderContainer>
  )
}

export default MobileTechnologyHeader
